import * as yup from "yup";

export type AdminChartBaseFormValues = {
  municipality: string;
  county: string;
  state: string;
  precinct: string;
  electionDate: string;
  showCandidateNames: boolean;
};

export const adminChartBaseValidationSchema = {
  municipality: yup.string().required("Municipality field is required"),
  county: yup.string().required("County field is required"),
  state: yup.string().required("State field is required"),
  precinct: yup.string().required("Precinct field is required"),
  electionDate: yup.string().required("Election date is required"),
  showCandidateNames: yup.bool().required().default(false),
};
